var _defs, _path, _path2, _path3, _path4, _mask, _use, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 123,
    height: 24,
    viewBox: "0 0 123 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-logo-a",
    x1: "50%",
    x2: "50%",
    y1: "95.489%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#082FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0E71E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-logo-b",
    x1: "50%",
    x2: "50%",
    y1: "95.489%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#082FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.485%",
    stopColor: "#0E71E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1095F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-logo-c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "94.657%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0F9FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#154ADD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-logo-d",
    x1: "50%",
    x2: "50%",
    y1: "4.423%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0073E2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "svg-logo-e",
    d: "M18.69 10.716c-.793 2.067-2.665 3.667-4.802 4.106-2.137.439-4.47-.298-5.99-1.89-1.636-1.717-2.237-4.158-3.137-6.368C3.86 4.355 2.32 2.086 0 1.712 1.274.548 2.888-.122 4.594.018a6.376 6.376 0 0 1 4.417 2.377c1.194 1.506 1.663 3.473 2.665 5.119.735 1.208 1.837 2.372 3.081 3.017 1.016.526 2.75.937 3.934.185"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-logo-a)",
    d: "M14.079 20.764l7.76-15.85c0-.004-4.438-.997-6.181 2.435a3672.246 3672.246 0 0 1-6.32 12.255c1.024 1.042 1.877 1.647 2.56 1.814.683.167 1.41-.051 2.181-.654z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-logo-b)",
    d: "M18.857 18.234l6.958-13.612s3.158-7.259 11.323-3.583c0 0-1.762.687-3.88 3.95-3.428 5.284-7.398 14.656-7.398 14.656-1.508 1.408-2.664 2.036-3.467 1.884-.854-.161-2.033-1.26-3.536-3.295z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-logo-c)",
    d: "M14.165 20.581c-.602 1.58-2.02 2.79-3.654 3.124-1.605.33-3.374-.228-4.511-1.424-1.254-1.306-1.71-3.151-2.391-4.824-.683-1.668-1.85-3.384-3.609-3.675.966-.872 2.189-1.378 3.474-1.286 1.3.12 2.54.785 3.338 1.791.922 1.158 1.278 2.646 2.03 3.905.564.898 1.4 1.778 2.346 2.251.765.413 2.08.724 2.977.138"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-logo-d)",
    d: "M25.864 19.582c-.795 2.068-2.666 3.668-4.803 4.106-2.137.44-4.471-.298-5.99-1.89-1.636-1.716-2.238-4.158-3.138-6.367-.9-2.21-2.44-4.479-4.76-4.852 1.274-1.164 2.888-1.834 4.594-1.694a6.376 6.376 0 0 1 4.417 2.376c1.194 1.506 1.663 3.474 2.665 5.12.735 1.207 1.837 2.371 3.08 3.016 1.016.526 2.75.938 3.935.185"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.402,
    transform: "translate(7.173 8.866)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "svg-logo-f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#svg-logo-e"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#svg-logo-d)",
    xlinkHref: "#svg-logo-e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-logo-a)",
    d: "M6.906 11.897l7.76-15.85c0-.003-4.438-.996-6.18 2.436a3672.252 3672.252 0 0 1-6.32 12.255c1.023 1.042 1.877 1.646 2.56 1.813.682.167 1.409-.05 2.18-.654z",
    mask: "url(#svg-logo-f)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.756 8.94l-2.046 8.218-2.187-7.983h-2.445l-2.21 7.983-2.023-8.219H41l3.433 11.775h2.445l2.422-7.677 2.422 7.677h2.446L57.6 8.94zM59.2 20.714h2.915V8.94H59.2v11.775zm0-13.564h2.915V4.23H59.2v2.92zM65.595 20.09c-.502-.573-.752-1.315-.752-2.225V3.052h2.915v13.612c0 .628.036 1.071.106 1.33.07.26.196.416.376.471.18.055.646.083 1.085.083v2.402h-1.472c-1.004 0-1.756-.287-2.258-.86M71.779 20.09c-.502-.573-.752-1.315-.752-2.225V3.052h2.915v13.612c0 .628.036 1.071.106 1.33.07.26.196.416.376.471.18.055.646.083 1.085.083v2.402h-1.473c-1.003 0-1.756-.287-2.257-.86M78.492 20.738c-.62-.142-1.012-.244-1.67-.542v-2.614c.658.393 1.286.687 1.858.883a5.427 5.427 0 0 0 1.775.295c1.191 0 1.787-.393 1.787-1.178 0-.424-.157-.75-.47-.977-.314-.228-.878-.498-1.693-.813-1.16-.424-2.014-.906-2.563-1.448-.549-.542-.823-1.275-.823-2.202 0-1.02.392-1.848 1.176-2.484.783-.636 1.842-.954 3.174-.954 1.332 0 2.547.306 3.645.918v2.666c-.596-.408-1.415-.891-1.94-1.111a4.255 4.255 0 0 0-1.658-.33c-.502 0-.89.102-1.164.306-.274.204-.411.495-.411.871 0 .299.082.542.247.73.164.189.395.358.693.507.298.15.792.357 1.482.624 1.144.44 1.967.922 2.469 1.448.501.526.752 1.229.752 2.108 0 1.115-.4 1.978-1.2 2.59-.799.613-1.935.919-3.409.919a9.26 9.26 0 0 1-2.057-.212M95.002 19.728l-.42.28c-.36.267-.776.49-1.246.671-.47.18-.925.27-1.364.27-1.74 0-3.006-.501-3.798-1.506-.791-1.005-1.187-2.394-1.187-4.169V8.94h2.916v6.335c0 1.1.184 1.912.552 2.438.368.526.96.789 1.776.789.909 0 1.645-.33 2.21-.99V8.94h2.899v.02M108.148 17.535c.478-.675.717-1.57.717-2.685 0-1.114-.239-2.009-.717-2.684-.478-.675-1.148-1.013-2.01-1.013-.988 0-1.725.33-2.21.99-.487.659-.73 1.562-.73 2.707 0 1.147.243 2.05.73 2.709.485.659 1.222.989 2.21.989.862 0 1.532-.338 2.01-1.013m1.282-7.96c.8.55 1.403 1.288 1.81 2.214.408.926.612 1.947.612 3.061 0 1.115-.204 2.136-.612 3.062a5.13 5.13 0 0 1-1.81 2.214c-.8.55-1.756.824-2.869.824-1.239 0-2.218-.338-3.221-1.013v.777h-2.916V3.052h2.916v6.759a5.287 5.287 0 0 1 3.221-1.06c1.113 0 2.07.275 2.869.824M116.601 15.298h-3.15v-2.214h3.15V9.93H119v3.155h3.15v2.214H119v3.155H116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.18 19.96c-.502-.573-.753-1.315-.753-2.225V8.959h2.916v7.575c0 .628.035 1.071.106 1.33.07.26.196.416.376.471.18.055.646.083 1.085.083v2.402h-1.473c-1.003 0-1.756-.287-2.257-.86"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c02e990bf5fbbc3108d61f35b6bf65cf.svg";
export { ForwardRef as ReactComponent };